require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-the-mills-4-1-lofts.json") })
        }
      }, "path---news-the-mills-4-1-lofts");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-the-mills-4-1-lofts!./.cache/json/news-the-mills-4-1-lofts.json
// module id = 852
// module chunks = 231608221292675